module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE0IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNMSAxQzEgMSA3LjMxNjY3IDcuMDExNTIgNy4wMDgxOSA2Ljk5OTk4QzYuNjk5NzIgNi45ODg0NSAxMyAxLjAxNjM3IDEzIDEuMDE2MzciIHN0cm9rZT0iIzU5NTg1OCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/down-arrow.svg
// module id = 58JP
// module chunks = 12